import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { AuthService } from "./auth.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { TranslateService } from "@ngx-translate/core";
import { HTTP_STATUS, ROLE_KEY } from "@app/common/constants";
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { response } from "@app/share/type";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

@Injectable({
  providedIn: 'root',
})
export class WhatsappEmbeddedSignupService {
  httpClient = inject(HttpClient);
  authService = inject(AuthService);
  nzMessageService = inject(NzMessageService);
  translate = inject(TranslateService);
  nzNotificationService = inject(NzNotificationService);
  companyID: string = '';
  WHATSAPP_EMBEDDED_SIGNUP_URL: string = environment.whatsappEmbeddedSignupApi + "/whatsapp/embedded-signup/bind";
  appId: string = '';
  graphApiVersion: string = '';
  configurationId: string = '';
  // featureType: string = '';
  solutionID: string = '';
  private isWhatsappBusinessAppOnboardingErrorStatus: number = 0;
  whatsappErrorStatusSubscription: BehaviorSubject<number> = new BehaviorSubject<number>(this.isWhatsappBusinessAppOnboardingErrorStatus);

  constructor() {
    this.initalizer(environment.whatsappId, environment.whatsappGraphApiVersion, environment.whatsappConfigurationId, environment.whatsappSolutionID)
  }

  getWhatsappEmbeddedSignupStatus() {
    return this.httpClient.get<response<{status: string} | null>>(environment.gatewayApi + '/bsapi/whatsapp/embedded-signup/status');
  }


  initalizer(appId: string, graphApiVersion: string, configurationId: string, solutionID: string) {
    const user = this.authService.getUser();
    if (!user || (user.role !== ROLE_KEY.SUPER_ADMIN && user.role !== ROLE_KEY.ADMIN)) {
      return;
    }
    // this.appId = appId;
    // this.graphApiVersion = graphApiVersion;
    // this.configurationId = configurationId;
    // // this.featureType = featureType;
    // this.solutionID = solutionID;
    // this.companyID = user.companyId || '';
    // (window as any).fbAsyncInit = function () {
    //   // JavaScript SDK configuration and setup
    //   (window as any).FB.init({
    //     appId: appId, // Facebook App ID
    //     // autoLogAppEvents : true ,
    //     cookie: true, // enable cookies
    //     xfbml: true, // parse social plugins on this page
    //     version: graphApiVersion //Graph API version
    //   });
    // };

    const sessionInfoListener = (event: any) => {
      console.log("event---------------", event);
      if (event.origin == null) {
        return;
      }

      // Make sure the data is coming from facebook.com
      if (!event.origin.endsWith("facebook.com")) {
        return;
      }

      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          // if user finishes the Embedded Signup flow
          if ((data.event === 'FINISH' && !data.data?.is_wa_login_user) || data.event === 'FINISH_ONLY_WABA') {
            const { phone_number_id, waba_id, business_id } = data.data;
            this.bindWhatsappEmbeddedSignup(phone_number_id, waba_id, business_id, data.event, 1, data);
          }
          // if user reports an error during the Embedded Signup flow
          else if (data.event === 'ERROR') {
            const { error_message } = data.data;
            console.error("error ", error_message);
          }
          // if user cancels the Embedded Signup flow
          else {
            const { current_step } = data.data;
            console.warn("Cancel at ", current_step);
          }
        }
      } catch {
        // Don’t parse info that’s not a JSON
        console.log('Non JSON Response', event.data);
      }
    };

    this.isWhatsappBusinessAppOnboardingErrorStatus = Number(localStorage.getItem("whatsappBusinessApiOnboardingErrorStatus") || '0');

    this.whatsappErrorStatusSubscription.next(this.isWhatsappBusinessAppOnboardingErrorStatus);
    window.addEventListener('message', sessionInfoListener);
    // this.loadFacebookSdk();
  }

  private bindWhatsappEmbeddedSignup(phone_number_id: string, waba_id: string, business_id: string, event: string, EmbeddingType: number, data: any) {
    const sub = this.httpClient.post(this.WHATSAPP_EMBEDDED_SIGNUP_URL, {
      waba_id,
      phone_number_id,
      business_id,
      event,
      solution_id: this.solutionID,
      company_id: this.companyID,
      embedding_type: EmbeddingType,
      data
    }).subscribe({
      next: (res: any) => {
        sub.unsubscribe();
        if (res?.code == HTTP_STATUS.SUCCESS) {
          this.nzMessageService.success(this.translate.instant("WhatsappEmbeddedSignupBindSuccess"));
        } else {
          this.nzNotificationService.error('',
            this.translate.instant("WhatsappEmbeddedSignupBindError", { WabaId: waba_id, PhoneNumberId: phone_number_id }),
            {
              nzDuration: 0
            }
          );
        }
      },
      error: (err) => {
        sub.unsubscribe();
        this.nzNotificationService.error('',
          this.translate.instant("WhatsappEmbeddedSignupBindError", { WabaId: waba_id, PhoneNumberId: phone_number_id }),
          {
            nzDuration: 0
          }
        );
      }
    })
  }

  loadFacebookSdk() {
    const fjs = document.getElementsByTagName('head')[0];
    if (document.getElementById('facebook-jssdk')) {
      return;
    }
    const js = document.createElement('script');
    js.id = 'facebook-jssdk';
    js.crossOrigin = 'anonymous';
    js.async = true;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.appendChild(js);
    js.onload = () => {
      this.isWhatsappBusinessAppOnboardingErrorStatus = 0;
      this.whatsappErrorStatusSubscription.next(this.isWhatsappBusinessAppOnboardingErrorStatus);
      console.log("whatsapp js loaded")
      localStorage.setItem("whatsappBusinessApiOnboardingErrorStatus", this.isWhatsappBusinessAppOnboardingErrorStatus.toString());
    }
    js.onerror = (e) => {
      console.error("whatsapp js error", e)
      this.isWhatsappBusinessAppOnboardingErrorStatus = 1;
      this.whatsappErrorStatusSubscription.next(this.isWhatsappBusinessAppOnboardingErrorStatus);
      localStorage.setItem("whatsappBusinessApiOnboardingErrorStatus", this.isWhatsappBusinessAppOnboardingErrorStatus.toString());
      // this.testMultipleExternalSources().then((isExternalAccessBlocked) => {
      //   if (isExternalAccessBlocked) {
      //   } else {
      //     this.isWhatsappBusinessAppOnboardingErrorStatus = 2;
      //   }
      // });
      // js.src = "./assets/js/whatsappEmbeddedSignupSdk.js";
    }
  }

  launchWhatsAppSignup() {
    // Launch Facebook login
    (window as any).FB?.login(function (response: any) {
      if (response.status === 'connected' && response.authResponse) {
        const code = response.authResponse.code;
        console.log('User authResponse code:', code);
        console.log("suess", response)
        // The returned code must be transmitted to your backend,
        // which will perform a server-to-server call from there to our servers for an access token
      } else {
        console.log("error", response)
        console.log('User cancelled login or did not fully authorize.');
      }
    }, {
      config_id: this.configurationId,
      response_type: 'code',    // must be set to 'code' for System User access token
      override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
      extras: {
        features: [
          {
            name: 'marketing_messages_lite',
          },
        ],
        // featureType : 'WA_EMBEDDED_SIGNUP' ,
        sessionInfoVersion: '3',
        // "version":"v3",
        setup: {
          solutionID: this.solutionID
        }
      },
    });
  }

  async testMultipleExternalSources() {
    const testUrls = [
      'https://cdnjs.cloudflare.com/ajax/libs/axios/0.21.1/axios.min.js',
      'https://cdn.jsdelivr.net/npm/lodash@4.17.21/lodash.min.js',
      'https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js'
    ];

    let failures = 0;

    await Promise.all(testUrls.map(async (url) => {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000);

        await fetch(url, {
          method: 'HEAD',
          mode: 'cors',
          signal: controller.signal
        });

        console.log(`Successfully loaded ${url}`);
        clearTimeout(timeoutId);
      } catch (error) {
        console.error(`Failed to load ${url}:`, error);
        failures++;
      }
    }));

    return failures > testUrls.length / 2;
  }
}